import { useQueryParams } from 'use-query-params'

import SuggestionsFilter from './SuggestionsFilter'
import ListFilter from './ListFilter'
import { formatTopicsAndKeywordsCount } from '../../../utils'

import s from './AppliedFilters.module.css'

type Props = {
  isSuggestionsFilter?: boolean
}

export const AppliedFilters = ({ isSuggestionsFilter }: Props) => {
  const [_, setQueryParams] = useQueryParams({})

  const handleClearFilter = (filters: string[]) => {
    const queryParamsFilter: Record<string, string | undefined> = {}
    filters.forEach(filter => {
      queryParamsFilter[filter] = undefined
    })

    setQueryParams({ ...queryParamsFilter })
  }

  return (
    <div className={s.wrapper}>
      {isSuggestionsFilter ? (
        <SuggestionsFilter
          onClearFilter={handleClearFilter}
          formatTopicsAndKeywordsCount={formatTopicsAndKeywordsCount}
        />
      ) : (
        <ListFilter
          formatTopicsAndKeywordsCount={formatTopicsAndKeywordsCount}
          onClearFilter={handleClearFilter}
        />
      )}
    </div>
  )
}
